export default "__VITE_ASSET__CkVlnT_z__"